// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 38 38"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M2.66406 16.4C2.66406 14.1598 2.66406 13.0397 3.10004 12.184C3.48353 11.4314 4.09545 10.8195 4.8481 10.436C5.70375 10 6.82385 10 9.06406 10H22.9307C25.1709 10 26.291 10 27.1467 10.436C27.8993 10.8195 28.5113 11.4314 28.8948 12.184C29.3307 13.0397 29.3307 14.1598 29.3307 16.4V22.2667C29.3307 24.5069 29.3307 25.627 28.8948 26.4826C28.5113 27.2353 27.8993 27.8472 27.1467 28.2307C26.291 28.6667 25.1709 28.6667 22.9307 28.6667H9.06406C6.82385 28.6667 5.70375 28.6667 4.8481 28.2307C4.09545 27.8472 3.48353 27.2353 3.10004 26.4826C2.66406 25.627 2.66406 24.5069 2.66406 22.2667V16.4Z"
      />
      <path
        fill="#fff"
        d="M12.9865 16.0643C12.9865 15.4279 12.9865 15.1097 13.1195 14.9321C13.2354 14.7773 13.4128 14.6804 13.6057 14.6667C13.827 14.6509 14.0947 14.8229 14.63 15.167L19.8871 18.5466C20.3516 18.8452 20.5838 18.9945 20.6641 19.1844C20.7342 19.3503 20.7342 19.5375 20.6641 19.7033C20.5838 19.8932 20.3516 20.0425 19.8871 20.3411L14.63 23.7207C14.0947 24.0648 13.827 24.2369 13.6057 24.2211C13.4128 24.2073 13.2354 24.1104 13.1195 23.9556C12.9865 23.778 12.9865 23.4598 12.9865 22.8234V16.0643Z"
      />
      <path
        stroke="#6421B9"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="M10.0931 34C11.8729 33.1464 13.8774 32.6667 15.9974 32.6667C18.1174 32.6667 20.1219 33.1464 21.9016 34M9.06406 28.6667H22.9307C25.1709 28.6667 26.291 28.6667 27.1467 28.2307C27.8993 27.8472 28.5113 27.2353 28.8948 26.4826C29.3307 25.627 29.3307 24.5069 29.3307 22.2667V16.4C29.3307 14.1598 29.3307 13.0397 28.8948 12.184C28.5113 11.4314 27.8993 10.8195 27.1467 10.436C26.291 10 25.1709 10 22.9307 10H9.06406C6.82385 10 5.70375 10 4.8481 10.436C4.09545 10.8195 3.48353 11.4314 3.10004 12.184C2.66406 13.0397 2.66406 14.1598 2.66406 16.4V22.2667C2.66406 24.5069 2.66406 25.627 3.10004 26.4826C3.48353 27.2353 4.09545 27.8472 4.8481 28.2307C5.70375 28.6667 6.82385 28.6667 9.06406 28.6667ZM14.63 23.7207L19.8871 20.3411C20.3516 20.0425 20.5838 19.8932 20.6641 19.7033C20.7342 19.5375 20.7342 19.3503 20.6641 19.1844C20.5838 18.9945 20.3516 18.8452 19.8871 18.5466L14.63 15.167C14.0947 14.8229 13.827 14.6509 13.6057 14.6667C13.4128 14.6804 13.2354 14.7773 13.1195 14.9321C12.9865 15.1097 12.9865 15.4279 12.9865 16.0643V22.8234C12.9865 23.4598 12.9865 23.778 13.1195 23.9556C13.2354 24.1104 13.4128 24.2073 13.6057 24.2211C13.827 24.2369 14.0947 24.0648 14.63 23.7207Z"
      />
    </g>
    <circle cx={29} cy={9} r={8} fill="#6421B9" stroke="#fff" strokeWidth={2} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M29 6V9V12M26 9H32"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0H32V32H0z" transform="translate(0 6)" />
      </clipPath>
    </defs>
  </svg>
);
const IconCreateInterview = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconCreateInterview;
